import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayee401kFund extends Layout {
    dataheaderPayee401kFund: DataHeader;
    panelPayee401kFund: Panel;
    sourcePayee401kFund: DataSource;
    textboxFundCode: Textbox;
    textboxFundName: Textbox;
}
